/**
 * Picks the backend for this build (T074a): the real AWS one when built with `VITE_BACKEND=aws`
 * (only scripts/deploy-app.sh does), otherwise the in-memory local one. The AWS code and its SDK
 * are a separate download that previews never fetch.
 */
import { readAwsConfig } from './aws-config';
import { createLocalBackend, type Backend } from './backend';

export const usesAwsBackend = (env: Record<string, string | undefined> = import.meta.env) =>
  env.VITE_BACKEND === 'aws';

export async function loadAwsBackend(
  env: Record<string, string | undefined> = import.meta.env,
): Promise<Backend> {
  const { createAwsBackend } = await import('./aws-backend');
  return createAwsBackend(readAwsConfig(env));
}

export { createLocalBackend };
